/**
 * The product's mark: a device (the dot) and the signal that reaches it. Drawn in `currentColor`, so
 * it takes the accent wherever it is placed. The tab icon is the same drawing on a dark tile, in
 * design/brand/mark.svg.
 */
export function BrandMark({ size = 20, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 52 52" aria-hidden="true" className={className}>
      <circle cx="17" cy="35" r="6" fill="currentColor" />
      <path d="M17 22a13 13 0 0 1 13 13" stroke="currentColor" strokeWidth="5" fill="none" strokeLinecap="round" />
      <path
        d="M17 11a24 24 0 0 1 24 24"
        stroke="currentColor"
        strokeWidth="5"
        fill="none"
        strokeLinecap="round"
        opacity="0.5"
      />
    </svg>
  )
}
